import { render } from "./FacturaDet.vue?vue&type=template&id=cc658998&scoped=true"
import script from "./FacturaDet.vue?vue&type=script&lang=js"
export * from "./FacturaDet.vue?vue&type=script&lang=js"

import "./FacturaDet.vue?vue&type=style&index=0&id=cc658998&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc658998"]])

export default __exports__